import { ItemStatus } from "@/models"

import { ItemSeverityLevel, ItemType } from "../Item"
import { Filter } from "../Pageable"

import type { StoryStatusGroup } from "../Item"

export class FilterBacklogMetrics extends Filter {
  text?: string
  sequenceNumberPrefix?: string
  itemTypes?: ItemType[]
  storyStatuses?: ItemStatus[]
  storyStatusGroup?: StoryStatusGroup[]
  excludeStoryStatuses?: ItemStatus[]
  ownerIds?: string[]
  teamIds?: string[]
  hasStoryPoints?: boolean
  hasEstimation?: boolean
  hasBacklogPriority?: boolean
  sprintIds?: string[]
  inSprint?: boolean
  epicIds?: string[]
  inEpic?: boolean
  startCreatedDateTime?: string
  endCreatedDateTime?: string
  hasActiveStoryPoker?: boolean
  includeTeamLessSupportCases?: boolean
  severityLevel?: ItemSeverityLevel[]
  hasEstimationOrStoryPoints?: boolean
  completed?: boolean
  inActiveSprint?: boolean
  inNotActiveSprint?: boolean
  teamId?: string
  currentProjectId?: string
  skipTeam?: boolean

  constructor(props?: Partial<FilterBacklogMetrics>) {
    super(props as FilterBacklogMetrics)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field] ?? this[field]
    })
  }

  getJsonObj() {
    const data = {
      text: this.text,
      sequenceNumberPrefix: this.sequenceNumberPrefix,
      itemTypes: this.itemTypes,
      storyStatuses: this.storyStatuses,
      storyStatusGroup: this.storyStatusGroup,
      excludeStoryStatuses: this.getExcludeStoryStatuses(),
      ownerIds: this.ownerIds,
      teamIds: this.skipTeam ? null : this.teamIds,
      hasStoryPoints: this.hasStoryPoints,
      hasEstimation: this.hasEstimation,
      hasBacklogPriority: this.hasBacklogPriority,
      sprintIds: this.sprintIds,
      inSprint: this.inSprint,
      epicIds: this.epicIds,
      inEpic: this.inEpic,
      startCreatedDateTime: this.startCreatedDateTime,
      endCreatedDateTime: this.endCreatedDateTime,
      hasActiveStoryPoker: this.hasActiveStoryPoker,
      includeTeamLessSupportCases: this.includeTeamLessSupportCases,
      severityLevel: this.severityLevel,
      hasEstimationOrStoryPoints: this.hasEstimationOrStoryPoints,
      completed: this.completed,
      inActiveSprint: this.inActiveSprint,
      inNotActiveSprint: this.inNotActiveSprint,
      teamId: this.skipTeam ? null : this.teamId,
      currentProjectId: this.currentProjectId
    }

    return super.getJsonObj({ params: data, withoutPagination: true })
  }

  static createBugMetricsFilterWithTeamId(teamId: string) {
    const props = {
      teamIds: [teamId],
      itemTypes: ["BUG"] as ItemType[],
      excludeStoryStatuses: ["DONE", "OBSOLETE"] as ItemStatus[],
      hasBacklogPriority: true
    }
    return new FilterBacklogMetrics(props)
  }

  static createBacklogMetricsFilterWithTeamId(teamIds: string[]) {
    const props = {
      teamIds,
      excludeStoryStatuses: ["DONE", "OBSOLETE"] as ItemStatus[],
      hasBacklogPriority: true,
      includeTeamLessSupportCases: true,
      inSprint: false
    }
    return new FilterBacklogMetrics(props)
  }

  static createBacklogMetricsFilterWithSprint({
    sprintIds,
    teamIds
  }: {
    sprintIds: string[]
    teamIds: string[]
  }) {
    const props = {
      excludeStoryStatuses: ["DONE", "OBSOLETE"] as ItemStatus[],
      hasBacklogPriority: true,
      includeTeamLessSupportCases: true,
      inSprint: true,
      teamIds,
      sprintIds
    }
    return new FilterBacklogMetrics(props)
  }

  getExcludeStoryStatuses() {
    if (this.storyStatuses && this.storyStatuses[0] === "ALL") {
      this.storyStatuses = []
      return []
    }

    if (!this.excludeStoryStatuses?.length) return []
    return this.excludeStoryStatuses.filter(status => !this.storyStatuses?.includes(status))
  }
}
